import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { BrokerHero } from "@/components/broker/BrokerHero";
import { BrokerProblem } from "@/components/broker/BrokerProblem";
import { BrokerDriverNetwork } from "@/components/broker/BrokerDriverNetwork";
import { BrokerHowItWorks } from "@/components/broker/BrokerHowItWorks";
import { BrokerNetworkVisual } from "@/components/broker/BrokerNetworkVisual";
import { BrokerPrivateNetworkDemo } from "@/components/broker/BrokerPrivateNetworkDemo";
import { BrokerFindDrivers } from "@/components/broker/BrokerFindDrivers";
import { BrokerSendJobs } from "@/components/broker/BrokerSendJobs";
import { BrokerLoadListDemo } from "@/components/broker/BrokerLoadListDemo";
import { BrokerDriverBenefit } from "@/components/broker/BrokerDriverBenefit";
import { BrokerCTA } from "@/components/broker/BrokerCTA";

export default function BrokerLanding() {
  return (
    <div data-testid="broker-landing-page" className="min-h-screen bg-white">
      <Header />
      <BrokerHero />
      <BrokerProblem />
      <BrokerDriverNetwork />
      <BrokerHowItWorks />
      <BrokerNetworkVisual />
      <BrokerPrivateNetworkDemo />
      <BrokerFindDrivers />
      <BrokerSendJobs />
      <BrokerLoadListDemo />
      <BrokerDriverBenefit />
      <BrokerCTA />
      <Footer />
    </div>
  );
}
